@if (trialPeriod && (status === 0 || status === 1)) {
<div class="pl-4 trial-message-container flex flex-row justify-start items-center">
  <div class="flex flex-row justify-start items-center gap-x-2.5">
    <div class="mat-body pr-4" [innerHTML]="trialDaysLeftText"></div>
    @if (!subscriptionPage && allowBuy) {
    <button mat-raised-button class="mat-warn" (click)="pay()">
      {{ l("Tenant.Trial.Action.Buy.Title") }}
    </button>
    }
  </div>
</div>
}

@if (status === 3) {
<div class="pl-4 trial-message-container flex flex-row justify-start items-center">
  <div class="mat-body pr-4" [innerHTML]="trialDaysLeftText"></div>
</div>
}

@if (status === 71) {
<div class="pl-4 trial-message-container flex flex-row justify-start items-center">
  <div class="mat-body pr-4" [innerHTML]="trialDaysLeftText"></div>
  <button mat-raised-button class="mat-warn" (click)="abandonCancellation()">
    Desistir do cancelamento
  </button>
</div>
}
